var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowItWorks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F28984",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 13.315c.368 0 .663-.369.663-.737v-2.8c0-.369-.295-.663-.664-.737-.368 0-.663.368-.663.737v2.8c0 .368.295.663.663.737Zm0-5.599c.368 0 .663-.368.663-.736a.66.66 0 0 0-.664-.664c-.368 0-.663.369-.663.664 0 .368.295.736.663.736Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.002 17A6.951 6.951 0 0 1 3 10c0-3.905 3.096-7 7.002-7a6.951 6.951 0 0 1 7.002 7c0 3.832-3.17 7-7.002 7Zm0-12.895c-3.243 0-5.896 2.653-5.896 5.895 0 3.242 2.653 5.895 5.896 5.895s5.896-2.653 5.896-5.895a5.866 5.866 0 0 0-5.896-5.895Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks);
export default __webpack_public_path__ + "static/media/how-it-works.b8a1b6d78e246a6a4e5d09b13d4ae419.svg";
export { ForwardRef as ReactComponent };